import { GridColumns } from 'shared/types';
import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import { AccountNumberParams } from 'pages/managePricing/managePricingResolver';
import { useParams } from 'react-router-dom';
import { TableDataPage } from 'shared/components';
import { createTableDataContext, ProvideTableData } from 'shared/providers/provideTableData';
import { AddDeviationsData } from 'types/backend';

interface ExclusiveProductsResolverProps {
    columnConfig: GridColumns<AddDeviationsData>
    toolbarChildren: JSX.Element[]
}

export const addDeviationsContext = createTableDataContext<AddDeviationsData>();
export function ExclusiveProductsResolver({columnConfig, toolbarChildren}: ExclusiveProductsResolverProps) {
    const params = useParams<AccountNumberParams>();

    const defaultExclusiveAddDeviationsConfig: {initialState?: GridInitialStatePremium} | undefined = {
        initialState: {
            pagination: {
                paginationModel: {
                    page: 0,
                    pageSize: 100,
                },
            }
        },
    }

    return (
        <ProvideTableData
            name='ProductListUI'
            tableDataContext={addDeviationsContext}
            alternateQueryPath={`subset/${params.accountNumber}/productList/exclusive`}
            config={defaultExclusiveAddDeviationsConfig}
        >
            <TableDataPage
                title='Available Exclusive Products'
                columnConfig={columnConfig}
                tableDataContext={addDeviationsContext}
                config={{
                    hideExport: true,
                }}
                customToolbarChildren={toolbarChildren}
            />
        </ProvideTableData>
    );
}
